<mat-sidenav-container fullscreen>
    <mat-sidenav-content>
        <app-header *ngIf="head_footer"></app-header>
        <div [ngClass]="{'iframe_head_spance': !head_footer,'main-content': head_footer}">
            <div *ngIf="marquetext" class="marquee-text">
                <mat-icon> rss_feed</mat-icon>
                <marquee width="100%" direction="left">{{marquetext}}</marquee>
            </div>
            
 <!-- casinoImg -->
 <ng-container *ngIf="tokenCheck">
  <div class="multi-card">
    <div class="scroll-card" style="padding: 14px;">
      <div class="itemsContain">
        <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
          <div class="card">
            <img
              src="https://images.supernowa.net/Document/GameImages/85246d801fef4d43a325637243661631_neon-thumbnails-18.png"
              class="card-img-top" alt="...">
            <div class="button"><a href="#"> Play Now</a></div>
          </div>
  
          <div class="card">
            <img
              src="https://images.supernowa.net/Document/GameImages/912af3fca2144874b7b7ab2de03cf63a_neon-thumbnails-13.png"
              class="card-img-top" alt="...">
            <div class="button"><a href="#"> Play Now</a></div>
          </div>
          
        </div>
        <div class="d-flex card-group" style="padding: 0px 5px 0px 5px;">
          <div class="card">
            <img
              src="https://images.supernowa.net/Document/GameImages/bce4691827854b14a631ba020001e847_neon-thumbnails-03.png"
              class="card-img-top" alt="...">
            <div class="button"><a href="#"> Play Now</a></div>
          </div>
  
          <div class="card">
            <img
              src="https://images.supernowa.net/Document/GameImages/7343dec5ab5b4a36a6f926874f216389_neon-thumbnails-02.png"
              class="card-img-top" alt="...">
            <div class="button"><a href="#"> Play Now</a></div>
          </div>
          
        </div>
  
        <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
          <div class="card">
            <img
              src="https://images.supernowa.net/Document/GameImages/bce4691827854b14a631ba020001e847_neon-thumbnails-03.png"
              class="card-img-top" alt="...">
            <div class="button"><a href="#"> Play Now</a></div>
          </div>
  
          <div class="card">
            <img
              src="https://images.supernowa.net/Document/GameImages/7343dec5ab5b4a36a6f926874f216389_neon-thumbnails-02.png"
              class="card-img-top" alt="...">
            <div class="button"><a href="#"> Play Now</a></div>
          </div>
          
        </div>
        <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
          <div class="card">
            <img
              src="https://images.supernowa.net/Document/GameImages/0730f21c63544456a0fa1eb250ae4992_neon-thumbnails-17.png"
              class="card-img-top" alt="...">
            <div class="button"><a href="#"> Play Now</a></div>
          </div>
  
          <div class="card">
            <img
              src="https://images.supernowa.net/Document/GameImages/e910c519f92c41a58a9c59dc09e11250_neon-thumbnails-14.png"
              class="card-img-top" alt="...">
            <div class="button"><a href="#"> Play Now</a></div>
          </div>
          
        </div>
        <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
          <div class="card">
            <img
              src="https://images.supernowa.net/Document/GameImages/da0706276b4444d491846159bb1bf07a_neon-thumbnails-09.png"
              class="card-img-top" alt="...">
            <div class="button"><a href="#"> Play Now</a></div>
          </div>
  
          <div class="card">
            <img
              src="https://images.supernowa.net/Document/GameImages/1afe8e32eb0d43a496d56979bf5e8b60_neon-thumbnails-10.png"
              class="card-img-top" alt="...">
            <div class="button"><a href="#"> Play Now</a></div>
          </div>
          
        </div>
        <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
          <div class="card">
            <img
              src="https://images.supernowa.net/Document/GameImages/89685a59c2dc46429b805875c37066a6_neon-thumbnails-16.png"
              class="card-img-top" alt="...">
            <div class="button"><a href="#"> Play Now</a></div>
          </div>
  
          <div class="card">
            <img
              src="https://images.supernowa.net/Document/GameImages/8e0efab978a14ed483a794f9bb71ff96_neon-thumbnails-19.png"
              class="card-img-top" alt="...">
            <div class="button"><a href="#"> Play Now</a></div>
          </div>
          
        </div>
        <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
          <div class="card">
            <img
              src="https://images.supernowa.net/Document/GameImages/d67c61187ab248a58aefdeceff2edd96_neon-thumbnails-06.png"
              class="card-img-top" alt="...">
              <div class="button"><a href="#"> Play Now</a></div>
          </div>
  
          <div class="card">
            <img
              src="https://images.supernowa.net/Document/GameImages/f42e05b9dcee4275b3e2addc2f73c606_neon-thumbnails-08.png"
              class="card-img-top" alt="...">
              <div class="button"><a href="#"> Play Now</a></div>
          </div>
          
        </div>
  
        <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
          <div class="card">
            <img
              src="https://images.supernowa.net/Document/GameImages/c33323b773474acf9f3c43b33e31ae91_neon-thumbnails-12.png"
              class="card-img-top" alt="...">
            <div class="button"><a href="#"> Play Now</a></div>
          </div>
  
          <div class="card">
            <img
              src="https://images.supernowa.net/Document/GameImages/6fbb02d51cf044ea856eaa77faa77cd6_neon-thumbnails-15.png"
              class="card-img-top" alt="...">
            <div class="button"><a href="#"> Play Now</a></div>
          </div>
          
        </div>
        <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
          <div class="card">
            <img
              src="https://images.supernowa.net/Document/GameImages/23bce1903ca24717bfa7e6958f026aee_neon-thumbnails-07.png"
              class="card-img-top" alt="...">
            <div class="button"><a href="#"> Play Now</a></div>
          </div>
  
          <div class="card">
            <img
              src="https://images.supernowa.net/Document/GameImages/2b26c9bd6797460dae6697ee093b0825_neon-thumbnails-05.png"
              class="card-img-top" alt="...">
            <div class="button"><a href="#"> Play Now</a></div>
          </div>
          
        </div>
        <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
          <div class="card">
            <img src="https://images.supernowa.net/Document/GameImages/2594257625a948feaf82aee8447a8cfc_23-RNG-queen.jpg"
              class="card-img-top" alt="...">
            <div class="button"><a href="#"> Play Now</a></div>
          </div>
  
          <div class="card">
            <img
              src="https://images.supernowa.net/Document/GameImages/198dec4fe9634a0493825705892cbd1f_neon-thumbnails-11.png"
              class="card-img-top" alt="...">
            <div class="button"><a href="#"> Play Now</a></div>
          </div>
         
        </div>
        <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
          <div class="card">
            <img
              src="https://images.supernowa.net/Document/GameImages/c88fc9c1bfc34e97b8e96a80007e34cf_neon-thumbnails-01.png"
              class="card-img-top" alt="...">
            <div class="button"><a href="#"> Play Now</a></div>
          </div>
  
        </div>
  
      </div>
                          
    </div>
  
  </div>
  </ng-container>
 <!-- casinoImgEnd -->
    
          <!-- offerDesign end-->
 
          <div _ngcontent-qwe-c6="" class="evetn-main-wrapper events-card-main" *ngIf="marketBattle">
            <div _ngcontent-qwe-c6="" class="container-fluid">
               <div _ngcontent-qwe-c6="" class="left-div-w-70">
                  <!----><!---->
                  <div _ngcontent-qwe-c6="" class="event-box ng-tns-c6-0 ng-trigger ng-trigger-fadeInOut ng-star-inserted"><button _ngcontent-qwe-c6="" class="back-button" (click)="back()"><i _ngcontent-qwe-c6="" class="fa fa-arrow-left" aria-hidden="true"></i></button> {{marketBattle.eventName}} <span style="border:1px solid rgb(242, 174, 25);padding:5px;" _ngcontent-qwe-c6="" (click)="openModalRules(fantastyrule)" class="rule">Rules</span></div>
                  <!----><!----><!---->
                  <div _ngcontent-qwe-c6="" class="left-side start-evetns w-100 ng-tns-c6-0 ng-trigger ng-trigger-fadeInOut ng-star-inserted">
                     <div _ngcontent-qwe-c6="" class="shadow-box">
                        <div _ngcontent-qwe-c6="" class="flex-container-box teamboxformmob ks">
                           <div _ngcontent-qwe-c6="" class="fixed-logo  l1"><img _ngcontent-qwe-c6="" class="ng-tns-c6-0" alt="team-logo" height="256" loading="lazy" width="255" src="assets/fantasty/{{(marketBattle?.slug).split('VS')[0].trim()}}.png" (error) ="onImgError($event)"></div>
                           <div _ngcontent-qwe-c6="" class="text-container">
                           <div class="teamsname">  <h4 _ngcontent-qwe-c6="" class="ng-tns-c6-0">{{(marketBattle?.slug).split('VS')[0]}} <span _ngcontent-qwe-c6="" class="ng-tns-c6-0">{{(marketBattle?.eventName).split('vs')[0]}}</span></h4>
                              <strong _ngcontent-qwe-c6="" class="ng-tns-c6-0">VS</strong>
                              <h4 _ngcontent-qwe-c6="" class="ng-tns-c6-0">{{(marketBattle?.slug).split('VS')[1]}} <span _ngcontent-qwe-c6="" class="ng-tns-c6-0">{{(marketBattle?.eventName).split('vs')[1]}}</span></h4>
                            </div> 
                            <!---->
                              <div _ngcontent-qwe-c6="" class="flex-items ng-tns-c6-0 ng-star-inserted" style="">
                                 <h6 _ngcontent-qwe-c6="" class="ng-tns-c6-0">Min Stake<span _ngcontent-qwe-c6="" class="ng-tns-c6-0">{{marketBattle?.minlimit}}</span></h6>
                                 <h6 _ngcontent-qwe-c6="" class="ng-tns-c6-0">Max Stake<span _ngcontent-qwe-c6="" class="ng-tns-c6-0">{{marketBattle?.maxlimit}}</span></h6>
                                 <h6 _ngcontent-qwe-c6="" class="ng-tns-c6-0">Top Loss Run<span _ngcontent-qwe-c6="" class="ng-tns-c6-0">100.0</span></h6>
                              </div>
                           </div>
                           <div _ngcontent-qwe-c6="" class="fixed-logo l2"><img _ngcontent-qwe-c6="" class="ng-tns-c6-0" alt="team-logo" height="256" loading="lazy" width="255" src="assets/fantasty/{{(marketBattle?.slug).split('VS')[1].trim()}}.png" (error) ="onImgError($event)"></div>
                        </div>
                        <!---->
                        <div _ngcontent-qwe-c6="" *ngIf="!runningStatus" class="display-flex ng-tns-c6-0 ng-star-inserted" style="">
                           <p _ngcontent-qwe-c6="" class="ng-tns-c6-0">If you start first, <strong _ngcontent-qwe-c6="" class="ng-tns-c6-0">Computer gets a {{marketBattle.marketBook.computerPoint}} run advantage</strong></p>
                           <p _ngcontent-qwe-c6="" class="ng-tns-c6-0">If the computer start first, <strong _ngcontent-qwe-c6="" class="ng-tns-c6-0">You gets a {{marketBattle.marketBook.userPoint}} run advantage</strong></p>
                        </div>
                        <!---->

                        <div _ngcontent-uxm-c6=""  *ngIf="runningStatus" class="display-flex text-center ng-tns-c6-0 ng-star-inserted" style="">
                          <!----><!---->
                          <p _ngcontent-uxm-c6="" *ngIf="firstSelected=='1'" class="ng-tns-c6-0 ng-star-inserted"><span _ngcontent-uxm-c6="" class="pbcomp">Player</span> start! <strong _ngcontent-uxm-c6="" class="ng-tns-c6-0"><span _ngcontent-uxm-c6="" class="pbplayer">Computer</span> awarded {{marketBattle?.marketBook?.computerPoint}} run advantage</strong></p>
                          
                          <p _ngcontent-uxm-c6="" *ngIf="firstSelected=='2'" class="ng-tns-c6-0 ng-star-inserted"><span _ngcontent-uxm-c6="" class="pbcomp">Computer</span> start! <strong _ngcontent-uxm-c6="" class="ng-tns-c6-0"><span _ngcontent-uxm-c6="" class="pbplayer">Player</span> awarded {{marketBattle?.marketBook?.userPoint}} run advantage</strong></p>
                        
                      
                        </div>
                     </div>
                     <!----><button _ngcontent-qwe-c6="" class="card-btn ng-tns-c6-0 ng-star-inserted" *ngIf="firstSelected==0" type="button" (click)="startGame(1);firstSelected='1'" style="">Player <strong _ngcontent-qwe-c6="" class="ng-tns-c6-0">Starts</strong></button><!----><button _ngcontent-qwe-c6="" class="card-btn red-card-bg ng-tns-c6-0 ng-star-inserted" type="button" style="" *ngIf="firstSelected==0" (click)="startGame(2);slectPlayerComputer();firstSelected='2'">Computer <strong _ngcontent-qwe-c6="" class="ng-tns-c6-0">Starts</strong></button><!---->
                  </div>
                  <!---->

                  <div _ngcontent-qwe-c6="" *ngIf="runningStatus && marketBattle" class="display-flex bg-black-div ng-tns-c6-0 ng-trigger ng-trigger-fadeInOut ng-star-inserted" style="">
                    <ul _ngcontent-qwe-c6="" class="player-card-list">
                       <!---->
                       <li _ngcontent-qwe-c6="" class="ng-tns-c6-0 ng-star-inserted  "   style="" *ngFor="let p of marketBattle.marketBook.runners" (click)="slectPlayerUser($event,p)" [ngClass]="{'selected-player': p.selected =='1', 'computer-slt' : p.selected == '2' ,'lock-player' : p.selected == '3'}">
                          
                          <h6 _ngcontent-qwe-c6="" class="ng-tns-c6-0">
                             <p _ngcontent-qwe-c6="" class="ng-tns-c6-0" style="font-weight: bold;">{{p?.runnerName}}</p>
                             <span _ngcontent-qwe-c6="" class="ng-tns-c6-0">Default Run: {{p?.runs}}</span>
                          </h6>
                       </li>
                     
                    </ul>
                 </div>
               </div>
               <!---->
               <div *ngIf="lodTimer" id="overlay" class="laodintime" style="height:100%;display:flex;align-items:center;justify-content:center;">
                <div style="font-size:7rem;" class="font-weight-bold text-warning">{{lodTimer}}</div>
            </div>
               <div _ngcontent-qwe-c6="" *ngIf="runningStatus"  [ngClass]="screenWidth <500 ? 'left-div-w-70' : 'right-side ng-tns-c6-0 ng-trigger ng-trigger-fadeInOut ng-star-inserted'" >
                <div _ngcontent-qwe-c6="" class="right-card-box stake-box active-stake-box">
                   <h4 _ngcontent-qwe-c6="" class="ng-tns-c6-0">Enter stake Amount</h4>
                   <div _ngcontent-qwe-c6="" class="stake-input-wrap" id="stakeBox"><input _ngcontent-qwe-c6="" [(ngModel)]="amount" class="stake-input ng-pristine ng-valid ng-touched" id="inpbox"  placeholder="00.00" type="number"><a _ngcontent-qwe-c6="" class="clear_btn"><i _ngcontent-qwe-c6="" class="fa fa-times" aria-hidden="true"></i></a></div>
                   <ul _ngcontent-qwe-c6="" class="stake-list">
                      <li _ngcontent-qwe-c6="" class="ng-tns-c6-0">
                         <h6 _ngcontent-qwe-c6="" class="ng-tns-c6-0">Min Stake</h6>
                         <span _ngcontent-qwe-c6="" class="ng-tns-c6-0">{{marketBattle?.minlimit}}</span>
                      </li>
                      <li _ngcontent-qwe-c6="" class="ng-tns-c6-0">
                         <h6 _ngcontent-qwe-c6="" class="ng-tns-c6-0">Max Stake</h6>
                         <span _ngcontent-qwe-c6="" class="ng-tns-c6-0">{{marketBattle?.maxlimit}}</span>
                      </li>
                      <li _ngcontent-qwe-c6="" class="ng-tns-c6-0">
                         <h6 _ngcontent-qwe-c6="" class="ng-tns-c6-0">Top Loss Run</h6>
                         <span _ngcontent-qwe-c6="" class="ng-tns-c6-0">100.0</span>
                      </li>
                   </ul>
                   <div _ngcontent-qwe-c6="" class="display-flex"><button _ngcontent-qwe-c6="" class="cancel-btn" type="button" (click)="clearBet()">Clear</button><button _ngcontent-qwe-c6="" class="submit-btn" type="button" (click)="placeBet()">Submit</button></div>
                   <p _ngcontent-qwe-c6="" class="ng-tns-c6-0"><i _ngcontent-qwe-c6="" class="ng-tns-c6-0">*once submitted,<u _ngcontent-qwe-c6="" class="ng-tns-c6-0">No change can be made</u></i></p>
                </div>
                <div _ngcontent-qwe-c6="" class="right-card-box blue-bg">
                   <h4 _ngcontent-qwe-c6="" class="ng-tns-c6-0">Player: {{userPlayer.length}}/4 <span _ngcontent-qwe-c6="" class="ng-tns-c6-0">selected</span></h4>
                   <ul _ngcontent-qwe-c6="" class="ng-tns-c6-0">
                      <!----><!----><!---->
                      <li _ngcontent-qwe-c6="" class="select-player ng-tns-c6-0 ng-trigger ng-trigger-fadeInOut ng-star-inserted" style="" *ngFor="let u of userPlayer"><i _ngcontent-qwe-c6="" class="fa fa-user" aria-hidden="true"></i> {{u.runnerName}} </li>
                            </ul>
                </div>
                <div _ngcontent-qwe-c6="" class="right-card-box bg-red">
                  <h4 _ngcontent-qxp-c54="" class="ng-tns-c54-6">Computer: {{computerPlayer.length}}/4 <span _ngcontent-qxp-c54="" class="ng-tns-c54-6">selected</span></h4>
                   <ul _ngcontent-qwe-c6="" class="ng-tns-c6-0">
                      <!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!---->
                      <li _ngcontent-qwe-c6="" class="select-player ng-tns-c6-0 ng-trigger ng-trigger-fadeInOut ng-star-inserted" style="" *ngFor="let u of computerPlayer"><i _ngcontent-qwe-c6="" class="fa fa-user" aria-hidden="true"></i> {{u.runnerName}} </li>
                      <!----><!----><!---->
                            </ul>
                </div>
             </div>
            </div>
         </div>
          
        </div>

        <ng-template #fantastyrule>
          <div matDialogTitle>
            <div class="rule-pop-content">
              <h4 class="modal-title">Term and Conditions</h4>

              <span  class="close" (click)="modalRef.hide()">&times;</span>

              <div _ngcontent-flk-c19="" class="modal-body">
                <p _ngcontent-flk-c19=""><strong _ngcontent-flk-c19="">1.</strong> Player battle is a skill game where any user can select real players and play against computer. <br _ngcontent-flk-c19=""><br _ngcontent-flk-c19=""><strong _ngcontent-flk-c19="">2.</strong> User can select his set of players based on the event type. For example, 2vs2, 4vs4 or 6vs6 based on the game category. <br _ngcontent-flk-c19=""><br _ngcontent-flk-c19=""><strong _ngcontent-flk-c19="">3.</strong> If the user selects first, the computer will get the default points. Vise versa if the computer selects first, the user will get the default points. (Default points are based on game category (2v2, 4v4, 6v6)) <br _ngcontent-flk-c19=""><br _ngcontent-flk-c19=""><strong _ngcontent-flk-c19="">4.</strong> If any player who has been selected is not included in playing 11 or didn't get opportunity to play (bat), Default points which was announced in advance will be given to them respectively. <br _ngcontent-flk-c19=""><br _ngcontent-flk-c19=""><strong _ngcontent-flk-c19="">5.</strong> User is allowed to make any changes in the team before placing the bet, Once the bet is confirmed user will not be allowed to make any change in the current team. However, user is allowed to create new team and participate. <br _ngcontent-flk-c19=""><br _ngcontent-flk-c19=""><strong _ngcontent-flk-c19="">6.</strong> Results will be announced post the match. <br _ngcontent-flk-c19=""><br _ngcontent-flk-c19=""><strong _ngcontent-flk-c19=""> 7.</strong> 1f the match got interrupted due to any situation such as rain/bad light and the match gets stopped. Default run/run scored whichever is the highest will be awarded for the players who haven't finished their quota. For example, Ina IND vs ENG T20 match England has completed playing 20 over and India got to play 10 over post that the match got stopped due to rain, Then Indian players will get points based on the above mentioned rule, (Note: This is not applicable to the player who has already got out before the match got stopped) </p>
             </div>
            </div>
          </div>
          
      </ng-template>
       
        <app-footer *ngIf="head_footer"></app-footer>
    </mat-sidenav-content>
 </mat-sidenav-container>